import React from 'react';
import VaultSaveModal from '@/features/vault/components/VaultSaveModal';

const DialogModals = ({
  showSaveIdeaDialog,
  setShowSaveIdeaDialog,
  messageToSave,
  messages,
  selectedMessages,
  setSelectedMessages,
  isSelectionMode,
  setIsSelectionMode,
}) => {
  return (
    <VaultSaveModal
      isOpen={showSaveIdeaDialog}
      onClose={() => {
        setShowSaveIdeaDialog(false);
        setSelectedMessages([]);
        setIsSelectionMode(false);
      }}
      message={messageToSave}
      messages={messages}
      selectedMessages={isSelectionMode ? selectedMessages : []}
    />
  );
};

export default DialogModals;
